module.exports = __webpack_public_path__ + "img/parent-node-active.8100fdd7.svg";